import { render, staticRenderFns } from "./matching-list-interests-user.vue?vue&type=template&id=1d3f4c97&scoped=true&"
import script from "./matching-list-interests-user.vue?vue&type=script&lang=ts&"
export * from "./matching-list-interests-user.vue?vue&type=script&lang=ts&"
import style0 from "./matching-list-interests-user.vue?vue&type=style&index=0&id=1d3f4c97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f4c97",
  null
  
)

export default component.exports